import type { UseFormSetError } from 'react-hook-form'
import type { FormValues } from '../form/schema'
import submitValidatePhoneNumber from '../lib/client/submitValidatePhoneNumber'
import sendLog from '../lib/sendLog'
import { INVALID_PHONE_NUMBER_ERROR_MESSAGE } from '../../constants/messages'

const validatePhoneNumber = async (
  { phoneNumber }: FormValues,
  reactHookFormSetError: UseFormSetError<FormValues>
): Promise<boolean> => {
  try {
    const isValid = await submitValidatePhoneNumber({
      phoneNumber: `+1${phoneNumber.replace(/\D/g, '')}`,
    })
    if (isValid) {
      return true
    }
  } catch (error) {
    sendLog(error as Error)
  }
  reactHookFormSetError('phoneNumber', {
    type: 'custom',
    message: INVALID_PHONE_NUMBER_ERROR_MESSAGE,
  })
  return false
}
export default validatePhoneNumber
